module.exports = __webpack_public_path__ + "static/media/choithramsWishlistBanner.7cd5a6f9.png";